// extracted by mini-css-extract-plugin
module.exports = {"new-table":"EvidenceTable_new-table__2CsrD","evidence-table-wrapper":"EvidenceTable_evidence-table-wrapper__2qrJK"};